var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSumOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 93.644 126.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5656",
    transform: "translate(-729.803 -1766.876)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 903",
    cx: 37.489,
    cy: 3.491,
    rx: 37.489,
    ry: 3.491,
    transform: "translate(739.149 1886.147)",
    fill: "#3db0f7",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5651"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2026",
    d: "M823.446 1811.047c0-24.395-20.95-44.171-46.793-44.171s-46.793 19.776-46.793 44.171c0 0-3.613 29.088 46.612 77.928 45.871-44.316 47.125-72.369 46.964-77.185.005-.248.01-.495.01-.743zm-46.974 28.011a28.73 28.73 0 1128.907-28.729 28.818 28.818 0 01-28.907 28.729z",
    fill: "#00AFF0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2027",
    d: "M823.295 1811.047c0-24.395-20.95-44.171-46.793-44.171h-.181v14.722a28.73 28.73 0 110 57.458v49.92c45.871-44.316 47.125-72.369 46.964-77.185.004-.249.01-.496.01-.744z",
    fill: "#00AFF0"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Road/Commute/Mileage (Expense Category)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 479",
    fill: "#00AFF0",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2030",
    d: "M790.818 1820.654l-6.563-25.378a1.313 1.313 0 00-1.269-.985h-12.252a1.313 1.313 0 00-1.269.985l-6.563 25.378a1.313 1.313 0 001.268 1.637h25.379a1.313 1.313 0 001.269-1.641zm-12.646-.985v-3.937a1.313 1.313 0 10-2.625 0v3.938h-9.681l5.885-22.754h3.8v3.5a1.313 1.313 0 002.625 0v-3.5h3.8l5.885 22.753z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2031",
    d: "M776.86 1806.001a.719.719 0 00-.719.719v2.637a.72.72 0 001.439 0v-2.637a.719.719 0 00-.72-.719z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumOther);
export default __webpack_public_path__ + "static/media/sum_other.5d4897c3fe8e400122fd2a21c84fdd11.svg";
export { ForwardRef as ReactComponent };